import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { IDeleteSectorsRequest } from "../../../../../../../service/resources/model/booking/air/IAirCreateBooking";

export interface ISectorAirDeleteDialogResponse {
  isDone: boolean;
  error?: any;
}

@Injectable({
  providedIn: 'root'
})
export class SectorAirDeleteDialogService {

  private sectorAirDeleteRequestSubject$: Subject<IDeleteSectorsRequest> = new Subject();
  public sectorAirDeleteRequestObs: Observable<IDeleteSectorsRequest> = this.sectorAirDeleteRequestSubject$.asObservable();

  private sectorAirDeleteResponseSubject$: Subject<ISectorAirDeleteDialogResponse> = new Subject();
  public sectorAirDeleteResponseObs: Observable<ISectorAirDeleteDialogResponse> = this.sectorAirDeleteResponseSubject$.asObservable();

  private sectorAirDeleteRefreshSubject$: Subject<void> = new Subject();
  public sectorAirDeleteRefreshObs: Observable<void> = this.sectorAirDeleteRefreshSubject$.asObservable();

  public delete(deleteSectorsRequest: IDeleteSectorsRequest): void {
    this.sectorAirDeleteRequestSubject$.next(deleteSectorsRequest);
  }

  public response(isDone: boolean, error?: any): void {
    this.sectorAirDeleteResponseSubject$.next({isDone, error});
  }

  public refreshBooking(): void {
    this.sectorAirDeleteRefreshSubject$.next();
  }
}
